export const arrangeDataForSheet = (row, data, gettext) => {
  return data.map((col) => {
    let value = row[col.field];
    if (row[col.field] === "summary") {
      value = gettext("Sum");
    }
    return col.type === 'number' && !value ? 0 : value;
  });
};